import { USER_ENDPOINTS } from "./endpoints";
import type { AuthResponse } from "./types";
import { apiPost, getSupabaseClient } from "../shared";

export default async function completeOAuthLogin(code: string): Promise<AuthResponse> {
  if (!code || typeof code !== "string") {
    throw new Error("Missing OAuth authorization code.");
  }

  const supabase = getSupabaseClient();
  const { data, error } = await supabase.auth.exchangeCodeForSession(code);

  if (error) {
    throw new Error(error.message || "Failed to complete Google login.");
  }

  const accessToken = data.session?.access_token;
  if (!accessToken) {
    throw new Error("OAuth session was created without an access token.");
  }

  const result = await apiPost<AuthResponse>(USER_ENDPOINTS.OAUTH_CALLBACK, { accessToken });

  // App session is the JWT cookie from our API; clear Supabase browser session to avoid stale GoTrue state.
  const { error: signOutError } = await supabase.auth.signOut();
  if (signOutError && import.meta.env.DEV) {
    console.warn("[completeOAuthLogin] supabase.auth.signOut:", signOutError.message);
  }

  // Do not dispatch `authChange`: `AuthCallback` calls `setAuthenticatedUser` with `result.user`.
  // Same race as email login if `checkAuth()` runs while post-login navigation is in flight.
  return result;
}
